import { render, staticRenderFns } from "./rolesList.vue?vue&type=template&id=4290c6c2&scoped=true&"
import script from "./rolesList.vue?vue&type=script&lang=js&"
export * from "./rolesList.vue?vue&type=script&lang=js&"
import style0 from "./rolesList.vue?vue&type=style&index=0&id=4290c6c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4290c6c2",
  null
  
)

export default component.exports